import { Component, OnInit, HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ReportingService } from '../services/reporting.service';

@Component({
  selector: 'app-mypatients',
  templateUrl: './mypatients.component.html',
  styleUrls: ['./mypatients.component.css']
})
export class MyPatientsComponent implements OnInit {

  public patients = [];
  public minDate = new Date("01/01/1900 00:00:00");

  constructor(private reportService: ReportingService, private router : Router) {}

  ngOnInit() {
    // Populate table with most recent test order list
    if (sessionStorage.getItem('myPatients'))
      this.patients = JSON.parse(sessionStorage.getItem('myPatients'));
  }

  getPatientTestList(patientId)
  {
    sessionStorage.removeItem('myTestOrders');
    this.reportService.getPatientTests(patientId).subscribe(
      (data : any)=>{
        sessionStorage.setItem('myTestOrders', JSON.stringify(data));
        this.router.navigate(['/reporting/testreportlist'], {queryParams: {caller: 'mypatients'}});
      },
      (err : HttpErrorResponse)=>{
        console.log(err);
      }
    );
  }
  checkForNull(patientDOB)
  {
    return new Date(patientDOB) > this.minDate;
  }
}
